import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { envAwarePost } from "../../util/util";
import isAlphanumeric from 'validator/lib/isAlphanumeric';
import isEmail from 'validator/es/lib/isEmail'
import debounce from "lodash.debounce"
import BasicInfo from "./BasicInfo";
import Personalize from "./Personalize";
import ClientProfile from "./ClientProfile"
import classes from "./Profile.module.css"
import { initUser } from "../users/usersSlice"
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import {Link} from 'react-router-dom'

function Profile() {

    let dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [profileData, setProfileData] = useState([]);
    const [errors, setErrors] = useState([]);

    const accountType = useSelector(state => state.users.current_user.account_type);
    const isTrainerOrGym = (accountType === "trainer" || accountType === "gym" || accountType === "chain");
    const isClient = accountType === "client" || accountType === 'prospect';
    const gymId = useSelector(state => state.users.current_user.gym_id);
    const isTrainer = accountType === "trainer";
    const isOwner = (
        parseInt(gymId) !== 0
        ? accountType === 'gym'
        : accountType === 'trainer'
    )
    const pageTypeText = (
        accountType === 'gym'
        ? 'Gym'
        : 'Trainer'
    )  
    const [nameInUseError, setNameInUseError] = useState(false);
    const [zipCodeNotFound, setZipCodeNotFound] = useState(false);

    useEffect(() => {
        envAwarePost('api/init/api.php', {
            action: 'getInitData',
            platform: 'web'
        })
            .then((res) => {
                if (res.success == "1") {
                    setProfileData(res.data)
                } else {
                    console.log(res)
                }

                setIsLoading(false);


            }).catch(err => console.log(err))
    }, [])
    // console.log('profileData: ', profileData)

    const debouncedEnvAwarePost = useCallback(debounce((name, updatedValue) =>
        saveToDb(name, updatedValue), 600), [])

    function saveToDb(name, updatedValue) {
        setNameInUseError(false);
        setZipCodeNotFound(false);
        envAwarePost("api/users/api", {
            action: 'updateProfileData',
            "field": name,
            "value": updatedValue
        }).then((res) => {
            console.log(res)
                if (res.success === "1") {
                    if (name === "user_name"||name==="headline") {
                        dispatch(initUser());
                    }
                } else {
                    if (res.message === "NameInUse") {
                        setNameInUseError(true);
                    } else if (res.message === "zipCodeNotFound") {
                        setZipCodeNotFound(true)
                    } else {
                        console.log(res.message)
                    }
                }
            })
    }

    function editDBItem(e, checkbox = 0) {
        let updatedValue = e.target.value;
        setErrors([]);
        
        if (!isAlphanumeric(e.target.value) && e.target.name == "pageAddress" && e.target.value != "") {
            setErrors(prev => ({ ...prev, pageAddress: "Please input alphanumeric characters only for your Page Address" }));
            return;
        }
        else if ((updatedValue.length == 0) && (e.target.name == "user_name")) {
            setErrors(prev => ({ ...prev, displayName: 'You must specify a Display Name' }));
            return;
        }
        else if ((updatedValue.length == 0 || !isEmail(updatedValue)) && e.target.name == "user_email") {
            setErrors(prev => ({ ...prev, contactEmail: 'You must specify a valid Contact Email.' }));
            return;
            // } else if(e.target.id === "socialLinks"){

        } else {
            if (checkbox == 1) {
                updatedValue = (e.target.checked) == true ? "1" : "0";
            }
            debouncedEnvAwarePost(e.target.name, updatedValue)
        }
    }

    return (

        <div className="pt-2 px-2 px-md-3">
            <strong className="d-block">
                Profile
            </strong>

            {isLoading ? <div
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    textAlign: "center",
                }}
            >
                <Spinner animation="border" role="status" variant="primary">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div> :
                <>
                    {isTrainerOrGym && <>
                        <div className="mt-3">
                            {isOwner&&
                                <Alert variant="success" className="text-dark">
                                    <strong>NEW</strong> You can now customize your {pageTypeText} Page & Custom Apps in the <Link to="/customization-dashboard">Customization Dashboard</Link>
                                </Alert>
                            }
                            <BasicInfo 
                                basicInfoData={profileData} 
                                editDBItem={editDBItem} 
                                setErrors={setErrors} 
                                errors={errors}
                            />
                            {/*<Personalize 
                                personalizeData={profileData}
                                editDBItem={editDBItem}
                                setErrors={setErrors}
                                errors={errors}
                                nameInUseError={nameInUseError}
                                zipCodeNotFound={zipCodeNotFound}
                            />*/}
                        </div>
                        <div style={{margin:"20px", float:"right"}}>
                            <i className="fas fa-info-circle"></i> Data is Automatically Saved
                        </div>
                    </>
                    }
                </>
            }
            {(isClient) && <ClientProfile />}
        </div >
    )
}

export default Profile;